@if (showBanner) {
  <div class="cookie-banner">
    <div class="cookie-content">
      <div class="cookie-text">
        <p>
          We use cookies to analyse site usage and improve your experience.
          By clicking "Accept All", you consent to the use of all cookies.
          <a routerLink="/privacy-policy">Privacy Policy</a>
        </p>
        <button class="details-toggle" (click)="showDetails = !showDetails">
          {{ showDetails ? 'Hide details' : 'Customise cookies' }}
        </button>
      </div>
      <div class="cookie-actions">
        <button class="btn btn-decline" (click)="declineAll()">Decline All</button>
        @if (showDetails) {
          <button class="btn btn-save" (click)="savePreferences()">Save Preferences</button>
        }
        <button class="btn btn-accept" (click)="acceptAll()">Accept All</button>
      </div>
    </div>
    @if (showDetails) {
      <div class="cookie-details">
        <div class="cookie-category">
          <div class="category-header">
            <div class="category-info">
              <h4>Analytics</h4>
              <p>Help us understand how visitors interact with the site by collecting usage data.</p>
            </div>
            <label class="toggle">
              <input type="checkbox" [checked]="analyticsEnabled" (change)="analyticsEnabled = !analyticsEnabled">
              <span class="toggle-slider"></span>
            </label>
          </div>
          <button class="cookie-list-toggle" (click)="showAnalyticsCookies = !showAnalyticsCookies">
            {{ showAnalyticsCookies ? 'Hide cookies' : 'View cookies' }}
          </button>
          @if (showAnalyticsCookies) {
            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>_ga</code></td>
                  <td>Stores a unique user ID to distinguish between users</td>
                </tr>
                <tr>
                  <td><code>_ga_*</code></td>
                  <td>Stores session data and campaign information for Google Analytics 4</td>
                </tr>
                <tr>
                  <td><code>_clck</code></td>
                  <td>Stores a unique user ID and preferences such as consent status</td>
                </tr>
                <tr>
                  <td><code>_clsk</code></td>
                  <td>Connects multiple page views by a user into a single session recording</td>
                </tr>
                <tr>
                  <td><code>CLID</code></td>
                  <td>Identifies the first-time Clarity saw this user on any site using Clarity</td>
                </tr>
              </tbody>
            </table>
          }
        </div>
        <div class="cookie-category">
          <div class="category-header">
            <div class="category-info">
              <h4>Advertising</h4>
              <p>Used to deliver relevant ads and measure advertising campaign performance.</p>
            </div>
            <label class="toggle">
              <input type="checkbox" [checked]="adsEnabled" (change)="adsEnabled = !adsEnabled">
              <span class="toggle-slider"></span>
            </label>
          </div>
          <button class="cookie-list-toggle" (click)="showAdsCookies = !showAdsCookies">
            {{ showAdsCookies ? 'Hide cookies' : 'View cookies' }}
          </button>
          @if (showAdsCookies) {
            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>ANONCHK</code></td>
                  <td>Indicates whether MUID is transferred to ANID (used only if site uses Bing ads)</td>
                </tr>
                <tr>
                  <td><code>MR</code></td>
                  <td>Indicates whether to refresh MUID</td>
                </tr>
                <tr>
                  <td><code>MUID</code></td>
                  <td>Identifies unique web browsers visiting Microsoft sites (used for advertising)</td>
                </tr>
                <tr>
                  <td><code>SM</code></td>
                  <td>Used in synchronising the MUID across Microsoft domains</td>
                </tr>
              </tbody>
            </table>
          }
        </div>
      </div>
    }
  </div>
}

@if (!showBanner) {
  <button class="cookie-settings-tab" (click)="openSettings()">
    <mat-icon>cookie</mat-icon>
  </button>
}
